export const JOB_OFFER_PERMISSION_CODES = {
    WEB_RECRUITMENT_JOB_OFFER_LIST: 'WEB_RECRUITMENT_JOB_OFFER_LIST',
    WEB_RECRUITMENT_JOB_OFFER_DETAIL: 'WEB_RECRUITMENT_JOB_OFFER_DETAIL',
    WEB_RECRUITMENT_JOB_OFFER_ADD: 'WEB_RECRUITMENT_JOB_OFFER_ADD',
    WEB_RECRUITMENT_JOB_OFFER_EDIT: 'WEB_RECRUITMENT_JOB_OFFER_EDIT',
    WEB_RECRUITMENT_JOB_OFFER_DELETE: 'WEB_RECRUITMENT_JOB_OFFER_DELETE',
    WEB_RECRUITMENT_JOB_OFFER_IMPORT: 'WEB_RECRUITMENT_JOB_OFFER_IMPORT',
    WEB_RECRUITMENT_JOB_OFFER_EXPORT: 'WEB_RECRUITMENT_JOB_OFFER_EXPORT',
} as const;

